import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Play, Search, Sparkles, ArrowRight, Star } from "lucide-react";

// Import Action
import { getTemplateCategoriesRequest } from "../store/slice/appSlice";
import { APP_STORE_URLS, CUSTOM_INVITATION_START_PRICE } from "../config/appConstants";
import { Smartphone } from "lucide-react";

export default function HomePage() {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  // Select Data from Redux
  const { 
    getTemplateCategoriesData, 
    getTemplateCategoriesLoading 
  } = useSelector((state) => state.app);

  // Fetch on Mount
  useEffect(() => {
    dispatch(getTemplateCategoriesRequest());
  }, [dispatch]);

  const categories = getTemplateCategoriesData || [];

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      
      {/* ================= HERO SECTION ================= */}
      <div className="relative pt-16 pb-20 px-6 overflow-hidden">
        {/* Background Decor */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-orange-100/50 rounded-full blur-[100px] pointer-events-none" />
        
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-yellow-100 text-yellow-800 text-xs font-bold uppercase tracking-wider mb-6">
            <Sparkles className="w-3 h-3" /> India's #1 Invitation Maker
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight tracking-tight">
            Design <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-yellow-500">Dream</span> <br />
            Invitations Instantly
          </h1>
          
          <p className="text-lg md:text-xl text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
            Create stunning <strong>Video & Card</strong> invites for Weddings, Birthdays, and Festivals. 
            No design skills needed. 100% customizable.
          </p>

          {/* Search Bar */}
          {/* <div className="max-w-2xl mx-auto bg-white p-2 rounded-full shadow-xl shadow-orange-100/50 flex items-center border border-gray-100 focus-within:ring-2 focus-within:ring-orange-200 transition-all">
             <div className="pl-4 text-gray-400">
               <Search className="w-5 h-5" />
             </div>
             <input 
               type="text" 
               placeholder="Try 'Haldi Ceremony' or 'First Birthday'..." 
               className="flex-1 px-4 py-3 outline-none text-gray-700 placeholder-gray-400 text-base bg-transparent"
               value={searchTerm}
               onChange={(e) => setSearchTerm(e.target.value)}
             />
             <button className="bg-gradient-to-r from-orange-500 to-yellow-500 text-white px-8 py-3 rounded-full font-bold hover:shadow-lg hover:scale-105 transition transform">
               Search
             </button>
          </div> */}

          {/* Popular Tags */}
          {/* <div className="mt-6 flex flex-wrap justify-center gap-3 text-sm text-gray-500">
            <span>Popular:</span>
            {['Wedding', 'Engagement', 'Birthday', 'Baby Shower'].map(tag => (
              <Link key={tag} to={`/category/${tag.toLowerCase()}`} className="hover:text-orange-600 underline decoration-orange-300 underline-offset-2 transition">
                {tag}
              </Link>
            ))}
          </div> */}
        </div>
      </div>

      {/* ================= CUSTOM INVITATION CTA ================= */}
      <div className="relative max-w-7xl mx-auto px-6 -mb-16 z-20">

        <div className="bg-white border border-gray-200 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-center justify-between shadow-xl">

          {/* LEFT CONTENT */}
          <div className="max-w-xl">

            <h2 className="text-xl md:text-2xl font-bold text-gray-900">
              🎨 Get Your Fully Custom Invitation Designed
            </h2>

            <p className="text-gray-600 mt-2 text-sm md:text-base">
              Share your details and get a professionally designed invitation tailored just for your event.
            </p>

            <p className="mt-3 font-semibold text-lg text-orange-600">
              Starting ₹{CUSTOM_INVITATION_START_PRICE} /-
            </p>

            <p className="text-xs text-gray-500 mt-1">
              Includes Premium Design + Countdown Slides (5, 7, 10 days)
            </p>

            <p className="text-xs text-gray-500 mt-1">
              ⚡ Delivery within 24–48 hours
            </p>

          </div>

          {/* RIGHT BUTTON */}
          <Link
            to="/custom-template-process"
            className="mt-5 md:mt-0 bg-gradient-to-r from-orange-500 to-yellow-500 text-white px-6 py-3 rounded-xl font-semibold shadow hover:shadow-xl hover:scale-105 transition"
          >
            Get Custom Invitation →
          </Link>

        </div>

      </div>

      {/* ================= MOBILE APP DOWNLOAD ================= */}
      <div className="bg-gradient-to-r from-orange-500 to-yellow-500 pt-28 pb-16 px-6">
        <div className="max-w-6xl mx-auto text-center text-white">

          {/* TOP BADGE */}
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/20 text-white text-xs font-semibold mb-4">
            <Smartphone className="w-4 h-4" />
            Available on Mobile
          </div>

          {/* HEADING */}
          <h2 className="text-3xl md:text-4xl font-bold mb-3 leading-tight">
            Create & Share Invitations <br className="hidden md:block" />
            Anytime, Anywhere 📱
          </h2>

          {/* SUBTEXT */}
          <p className="text-white/90 max-w-2xl mx-auto mb-6 text-sm md:text-base">
            Design, edit and download stunning invitations directly from your mobile.
            Fast, simple and made for instant sharing on WhatsApp & Instagram.
          </p>

          {/* FEATURES */}
          <div className="flex flex-wrap justify-center gap-3 mb-8 text-xs">
            <span className="bg-white/20 px-3 py-1 rounded-full">⚡ Fast Editing</span>
            <span className="bg-white/20 px-3 py-1 rounded-full">🎬 Video Templates</span>
            <span className="bg-white/20 px-3 py-1 rounded-full">📲 Instant Download</span>
          </div>

          {/* STORE BUTTONS */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            
            {APP_STORE_URLS.android && (
              <a
                href={APP_STORE_URLS.android}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-black hover:bg-gray-900 px-6 py-3 rounded-xl shadow-lg transition transform hover:scale-105"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Get it on Google Play"
                  className="h-8"
                />
              </a>
            )}

            {APP_STORE_URLS.ios && (
              <a
                href={APP_STORE_URLS.ios}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-black hover:bg-gray-900 px-6 py-3 rounded-xl shadow-lg transition transform hover:scale-105"
              >
                <img
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="Download on the App Store"
                  className="h-8"
                />
              </a>
            )}

          </div>

        </div>
      </div>


      {/* ================= CATEGORIES SECTION ================= */}
      <div className="max-w-7xl mx-auto px-6 py-10">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl font-bold text-gray-800">Explore Categories</h2>
          {/* <Link to="/categories" className="text-orange-600 font-medium hover:underline flex items-center gap-1">
            View All <ArrowRight className="w-4 h-4" />
          </Link> */}
        </div>
        
        {getTemplateCategoriesLoading ? (
          <div className="h-40 flex items-center justify-center text-gray-400">Loading Categories...</div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">

              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="min-w-[140px] md:min-w-[180px] group"
                >
                  <div className="relative rounded-2xl overflow-hidden shadow-sm border border-gray-100 group-hover:shadow-md transition-all duration-300">

                    {/* Image */}
                    <div className="aspect-[3/4] bg-gray-100 overflow-hidden">
                      <img
                        src={cat.file_url}
                        alt={cat.name}
                        className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
                      />
                    </div>

                    {/* Overlay */}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />

                    {/* Title */}
                    <div className="absolute bottom-2 left-2 right-2">
                      <h3 className="text-white text-sm md:text-base font-semibold leading-tight">
                        {cat.name}
                      </h3>
                      <p className="text-[10px] text-gray-200">
                        {cat.templates_count} Designs
                      </p>
                    </div>

                  </div>
                </Link>
              ))}

          </div>
        )}
      </div>

      {/* ================= TRENDING TEMPLATES ================= */}
      <div className="bg-white py-16 px-6 border-t border-gray-100 hidden">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-2">Trending This Week</h2>
            <p className="text-gray-500">Most loved templates by our community</p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 md:gap-8">
            {[1, 2, 3, 4].map((item, idx) => (
              <div key={item} className="group relative bg-gray-50 rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300">
                
                {/* Thumbnail Aspect Ratio (9:16 for Invites) */}
                <div className="aspect-[9/16] bg-gray-200 relative overflow-hidden">
                   {/* Placeholder for actual image */}
                   <div className="absolute inset-0 bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center text-gray-300">
                      <img 
                        src={`https://source.unsplash.com/random/400x600?wedding,invite&sig=${item}`} 
                        alt="Template" 
                        className="w-full h-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-700" 
                        onError={(e) => e.target.style.display = 'none'} // Fallback if image fails
                      />
                   </div>

                   {/* Badges */}
                   <div className="absolute top-3 left-3 flex gap-2">
                     {idx % 2 === 0 ? (
                       <span className="bg-yellow-400 text-yellow-900 text-[10px] font-bold px-2 py-1 rounded-md shadow-sm uppercase tracking-wide">Premium</span>
                     ) : (
                       <span className="bg-green-500 text-white text-[10px] font-bold px-2 py-1 rounded-md shadow-sm uppercase tracking-wide">Free</span>
                     )}
                   </div>

                   {/* Hover Overlay */}
                   <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center gap-3 backdrop-blur-[2px]">
                      <Link 
                        to={`/template/${item}`} 
                        className="bg-white text-gray-900 px-6 py-2.5 rounded-full font-bold text-sm shadow-lg hover:bg-orange-50 transform hover:scale-105 transition-all flex items-center gap-2"
                      >
                        <Play className="w-4 h-4 fill-current" /> Preview
                      </Link>
                   </div>
                </div>

                {/* Card Info */}
                <div className="p-4 bg-white relative z-10">
                  <div className="flex justify-between items-start mb-1">
                    <h3 className="font-bold text-gray-800 truncate pr-2">Royal Floral Wedding</h3>
                    <div className="flex items-center gap-1 text-xs text-yellow-500 font-medium">
                      <Star className="w-3 h-3 fill-current" /> 4.9
                    </div>
                  </div>
                  <p className="text-xs text-gray-500">Video Invitation</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Link to="/category/all" className="inline-block border-2 border-gray-900 text-gray-900 px-8 py-3 rounded-full font-bold hover:bg-gray-900 hover:text-white transition-colors uppercase text-sm tracking-wide">
              View All Templates
            </Link>
          </div>
        </div>
      </div>

      {/* ================= FEATURES / TRUST ================= */}
      <div className="bg-white border-t border-gray-100 py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="p-6">
              <div className="w-12 h-12 bg-orange-100 rounded-2xl flex items-center justify-center mx-auto mb-4 text-orange-600">
                <Sparkles className="w-6 h-6" />
              </div>
              <h3 className="font-bold text-lg mb-2">Easy Customization</h3>
              <p className="text-gray-500 text-sm">Edit text, photos, and music in seconds with our simple editor.</p>
            </div>
            <div className="p-6">
              <div className="w-12 h-12 bg-purple-100 rounded-2xl flex items-center justify-center mx-auto mb-4 text-purple-600">
                <Play className="w-6 h-6" />
              </div>
              <h3 className="font-bold text-lg mb-2">HD Video Download</h3>
              <p className="text-gray-500 text-sm">Get crystal clear full HD videos perfect for WhatsApp & Instagram.</p>
            </div>
            <div className="p-6">
              <div className="w-12 h-12 bg-green-100 rounded-2xl flex items-center justify-center mx-auto mb-4 text-green-600">
                <Star className="w-6 h-6" />
              </div>
              <h3 className="font-bold text-lg mb-2">Premium Designs</h3>
              <p className="text-gray-500 text-sm">Access thousands of professionally crafted templates.</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}